import { TemaCard } from 'src/data/models/TemaCardModel';

export const spanishSlangCards: TemaCard[] = [
    // 🏙 Common Slang
    new TemaCard(
        'slang1',
        'Slang',
        'phrase',
        '¡Qué guay! / ¡Qué chulo!',
        'How cool! (Literally: How cute!)',
        'Common expression used in Spain to show admiration or approval.',
    ),

    new TemaCard(
        'slang2',
        'Slang',
        'phrase',
        'Estás de coña / Estás de broma',
        'You’re joking! (Literally: you are in joke mode)',
        'An expression to tell someone they are joking or being playful.',
    ),

    // 🥳 Party & Social Slang
    new TemaCard(
        'slang3',
        'Slang',
        'phrase',
        '¿Nos vamos de fiesta? / ¿Vamos a pegar la fiesta?',
        'Let’s go to the party!',
        'Informal invitation to go out and party.',
    ),

    new TemaCard(
        'slang4',
        'Slang',
        'word',
        'juerga / fiesta',
        'party, fun, spree',
        'Used to describe a lively time or a celebration.',
        [
            { spanish: 'juerga', english: 'party, fun, spree' },
            { spanish: 'fiesta', english: 'party' },
        ]
    ),

    // 👥 Youth & Generational Slang
    new TemaCard(
        'slang5',
        'Slang',
        'phrase',
        '¡Eres un crack! / ¡Eres un genio!',
        'You are awesome! / You’re a genius!',
        'A phrase used to compliment someone for doing something impressive.',
    ),

    new TemaCard(
        'slang6',
        'Slang',
        'phrase',
        '¡Qué caña! / ¡Qué flipante! / ¡Qué fuerte!',
        'That’s amazing! / That’s awesome! / That’s crazy!',
        'A phrase used to express excitement or admiration.',
    ),

    // 🍻 Bar & Street Language
    new TemaCard(
        'slang7',
        'Slang',
        'phrase',
        '¿Te apuntas a unas cañas? / ¿Nos vamos de tapas?',
        'Want to go for some drinks? / Shall we go for tapas?',
        'Informal invitations to go for drinks or small dishes.',
    ),

    new TemaCard(
        'slang8',
        'Slang',
        'word',
        'guiri',
        'foreigner (often used jokingly)',
        'A playful term used to refer to a foreigner, especially in tourist-heavy areas.',
        [
            { spanish: 'extranjero', english: 'foreigner' },
            { spanish: 'forastero', english: 'foreigner' },
        ]
    ),

    // 💬 Phrases & Expressions
    new TemaCard(
        'slang9',
        'Slang',
        'phrase',
        '¡No me jodas! / ¡No me fastidies!',
        'Don’t mess with me!',
        'Used to express frustration or disbelief.',
    ),

    new TemaCard(
        'slang10',
        'Slang',
        'word',
        'peliagudo / arriesgado',
        'risky, tricky, dangerous',
        'Used to describe something risky or complicated.',
        [
            { spanish: 'peliagudo', english: 'risky, tricky' },
            { spanish: 'arriesgado', english: 'risky' },
        ]
    ),

    // 😂 Funny & Casual Slang
    new TemaCard(
        'slang11',
        'Slang',
        'phrase',
        '¡Vas a flipar! / ¡Te vas a quedar flipado!',
        'You’re going to flip out!',
        'Used when something is surprising or impressive.',
    ),

    new TemaCard(
        'slang12',
        'Slang',
        'word',
        'chaval/a',
        'kid, young person',
        'A colloquial way of referring to a young person, often used in an affectionate or casual manner.',
        [
            { spanish: 'niño/a', english: 'child' },
            { spanish: 'joven', english: 'youth' },
        ]
    ),
    new TemaCard(
        'slang13',
        'Slang',
        'phrase',
        'Molar',
        'To be cool/awesome',
        'This word is used to describe something you really like or think is cool. It is similar to saying "that rocks!" in English.',
    ),

    new TemaCard(
        'slang14',
        'Slang',
        'phrase',
        'A toda leche',
        'Very fast',
        'Refers to doing something very quickly or in a hurry. Can also refer to driving fast.',

    ),
    new TemaCard(
        'slang15',
        'Slang',
        'phrase',
        'Pillar a alguien',
        'To catch someone (in the act)',
        'This slang is used to refer to catching someone doing something they shouldn\'t be doing, or catching them by surprise.',

    ),
    new TemaCard(
        'slang16',
        'Slang',
        'phrase',
        'Pasarse de la raya',
        'To go too far',
        'Used when someone has crossed a line or done something inappropriate.',
    ),

    new TemaCard(
        'slang17',
        'Slang',
        'phrase',
        'Dar caña',
        'To push hard or to go all out',
        'This expression is used to describe someone who is working hard, pushing through, or doing something with a lot of effort.',
    ),
    new TemaCard(
        'slang18',
        'Slang',
        'phrase',
        'No tener pelos en la lengua',
        'To speak one\'s mind',
        'This idiomatic expression means to say exactly what you think without hesitation or filter.',
    ),

    new TemaCard(
        'slang19',
        'Slang',
        'phrase',
        '¡Mola un montón!',
        'It\'s awesome!',
        'Used to express that something is really cool or impressive.',
    ),

    new TemaCard(
        'slang20',
        'Slang',
        'phrase',
        'Tío/Tía',
        'Dude/Chick (informal)',
        'Informal way to refer to a friend or acquaintance. "Tío" means uncle, but in this case, it is similar to saying "dude". "Tía" is used for women and has a similar meaning.',
        [
            { spanish: 'Tío', english: 'Dude' },
            { spanish: 'Tía', english: 'Chick' },
        ]
    ),
];
